"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOOLEAN_TYPED_FILTERS_MAP = void 0;
exports.BOOLEAN_TYPED_FILTERS_MAP = {
    RE_DOWNLOAD: true,
    DID_WIN: true,
    SOURCE_APP_ID_PRESENT: true,
};
